// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

// This normally comes from the Buyapowa CDN but we've added it here to mock it easily
export const getBuyapowa = () => {
  return Buyapowa;
};
